class DataLayer {
	constructor() {
        window.dataLayer = window.dataLayer || [];
	}

	setEvent(event, data = {}) {
            if (!this.hasEvent(event)) {
                window.dataLayer.push({
                    event,
                    ...data,
                });
            }
	}

	hasEvent(event) {
		    return window.dataLayer.filter(data => data.event === event).length > 0;
	}

    push(event) {
        return window.dataLayer.push(event);
    }
}

export default new DataLayer();
